import { jsxs as l, jsx as m } from "react/jsx-runtime";
import { forwardRef as v, useMemo as g } from "react";
import { SearchBox as x } from "./components/SearchBox/index.js";
import { Container as h, Overlay as C } from "./style.js";
import { SearchNavigationEvent as S } from "./types.js";
import { SearchSuggestionsEvent as F } from "./types.js";
import { SearchBarContext as p } from "./context.js";
import { Suggestions as u } from "./components/Suggestions/index.js";
import { SuggestionItem as y } from "./components/SuggestionItem/index.js";
const j = v(function({
  isSearchBarDropdownOpen: o,
  children: a,
  commands: r,
  defaultValue: t,
  inputRef: e,
  isInputOpen: i,
  ...n
}, c) {
  const f = () => {
    r({ type: S.Close, payload: void 0 });
  }, s = g(
    () => ({
      isSearchBarDropdownOpen: o,
      commands: r,
      defaultValue: t,
      inputRef: e,
      isInputOpen: i
    }),
    [r, t, e, i, o]
  );
  return /* @__PURE__ */ l(p.Provider, { value: s, children: [
    /* @__PURE__ */ m(h, { ...n, ref: c, children: a }),
    o && /* @__PURE__ */ m(C, { onClick: f })
  ] });
}), q = {
  Root: j,
  SearchBox: x,
  Suggestions: u,
  SuggestionItem: y
};
export {
  j as Root,
  S as SearchNavigationEvent,
  F as SearchSuggestionsEvent,
  q as Searchbar
};
